module.exports = __webpack_public_path__ + "img/joinCurveWhite.473c040e.svg";